'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './account-not-active.routes';

export class AccountNotActiveComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('appApp.account-not-active', [uiRouter])
  .config(routes)
  .component('accountNotActive', {
    template: require('./account-not-active.html'),
    controller: AccountNotActiveComponent,
    controllerAs: 'accountNotActiveCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/account-not-active/account-not-active.component.js